import React, { useEffect, useState } from "react";
import RideTable from "./RideTable";
import styled from "styled-components";
import { AiFillCar } from "react-icons/ai";
import { MdOutlineNotificationsNone } from "react-icons/md";
import { FcDownload } from "react-icons/fc";
import { IconButton } from "@material-ui/core";
import { CloudDownloadOutlined, RefreshRounded } from "@material-ui/icons";
import api from "../../../services/api";
import CircularLoader from "../../UI/Loader";
import { Pagination } from "@material-ui/lab";
import { COLORS } from "../../../assets/colors";

function RidesInfo() {
  const [rides, setRides] = useState(null);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [ridesCount, setRidesCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const pageSize = 15;
  const limit = 15;
  const offset = (page - 1) * pageSize;

  useEffect(() => {
    fetchRides();
  }, [page]);

  const fetchRides = async () => {
    try {
      setLoading(true);
      const response = await api.get("admin/ride/", {
        params: { limit, offset },
      });

      if (response.status == 200) {
        setLoading(false);
        setRides(response.data.data);
        setRidesCount(response.data.totalRides);
      }
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (ridesCount > 0) {
      setPages(Math.ceil(ridesCount / pageSize));
    }
  }, [ridesCount]);
  const handleChange = (event, value) => {
    setPage(value);
  };
  return (
    <PageWrapper>
      <PageHeader>
        <div className="header-text">
          <h1>Rides Detail</h1>
          <p>Monitor and manage all active and scheduled rides.</p>
        </div>
        <HeaderActions>
          <IconButton onClick={fetchRides}>
            <RefreshRounded />
          </IconButton>
          <IconButton className="download-btn">
            <CloudDownloadOutlined />
          </IconButton>
        </HeaderActions>
      </PageHeader>

      <TableCard>
        {loading ? (
          <CircularLoader isLoading={loading} />
        ) : (
          <RideTable rides={rides} />
        )}
      </TableCard>

      <PaginationWrapper>
        {pages > 1 && rides?.length >= 1 && (
          <Pagination
            onChange={handleChange}
            size="large"
            page={page}
            count={pages}
            color="primary"
          />
        )}
      </PaginationWrapper>
    </PageWrapper>
  );
}

export default RidesInfo;
const Wrapper = styled.div`
  width: 100%;
  background: white;
  padding: 1rem;
  border-radius: 4px;
  height: 100%;
  .ride-table {
    width: 100%;
    margin: 0 auto;
    margin-top: 1rem;
  }
  .pagination {
    width: 100%;
    height: 3rem;
    display: flex;
    justify-content: center;
    padding: 2rem;
    margin-bottom: 4rem;
  }
`;

const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .header-text {
    h1 {
      margin: 0;
      font-size: 1.875rem;
      font-weight: 700;
      color: ${COLORS.adminTextPrimary};
    }
    p {
      margin: 0.5rem 0 0 0;
      color: ${COLORS.adminTextSecondary};
      font-size: 1rem;
    }
  }
`;

const HeaderActions = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;

  .download-btn {
    background: ${COLORS.adminAccent};
    color: white;
    &:hover {
      background: ${COLORS.adminAccent};
      opacity: 0.9;
    }
  }
`;

const TableCard = styled.div`
  background: ${COLORS.adminCardBg};
  border-radius: 12px;
  box-shadow: ${COLORS.adminShadow};
  border: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
`;

const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 1rem 0 3rem 0;
`;
